import { INotificationsContext } from './useNotificationsContext';

export type ActionTypes = 'showNotification' | 'closeNotification';

interface IPayload {
  delay?: INotificationsContext['delay'];
  text?: INotificationsContext['text'];
  detailsText?: INotificationsContext['detailsText'];
  variation?: INotificationsContext['variation'];
}

export interface IAction {
  type: ActionTypes;
  payload?: IPayload;
}

export function notificationsReducer(state: INotificationsContext, action: IAction): INotificationsContext {
  const { type, payload } = action;

  let newState = state;

  switch (type) {
    case 'showNotification': {
      newState = {
        ...state,
        delay: payload.delay,
        text: payload.text,
        detailsText: payload.detailsText,
        variation: payload.variation,
        visible: true,
      };
      break;
    }

    case 'closeNotification': {
      newState = {
        ...state,
        delay: 5000,
        visible: false,
      };
      break;
    }

    default:
      newState = state;
  }

  return newState;
}

export default notificationsReducer;
